export const theme = {
  breakpoint: {
    xs: '0px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px'
  },
  font: {
    family: {
      default: 'Helvetica, Arial, sans-serif'
    },
    weight: {
      default: 100
    },
    size: {
      default: '1.8rem',
      h1: '3.8rem',
      h2: '3.1rem',
      h3: '2.6rem',
      h4: '2.3rem',
      h5: '2.2rem',
      h6: '2.1rem'
    }
  },
  border: {
    size: '2px',
    radius: {
      edge: '2px',
      round: '100px'
    }
  },
  color: {
    default: '#2fa4e7',
    lightFont: '#ffffff',
    font: '#333333',
    border: '#2fa4e7',
    background: '#ffffff',
    primary: '#2fa4e7',
    secondary: '#e9ecef',
    tertiary: '#343a40',
    hover: '#178acc',
    focus: '#54b4eb',
    checked: '#2fa4e7',
    error: '#c71c22',
    disabled: '#acacac',
    success: '#73a839',
    info: '#04519b',
    warning: '#dd5600',
    danger: '#c71c22'
  }
};